import { registerLocaleData } from "@angular/common";
import localeRuBy from "@angular/common/locales/ru-BY";
import tk from "@angular/common/locales/tk";
import kkKZ from "@angular/common/locales/kk";
import { LOCALE_ID, NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { AppComponent } from "./app.component";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CoreModule } from "@core/core.module";
import { RouterModule as AppRouterModule } from "./router/router.module";
import { SharedModule } from "@shared/shared.module";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { CryptoMobileComponent } from "./crypto-mobile/crypto-mobile.component";
import { UserCoreModule } from "./user/user-core/user-core.module";
import { TranslationService } from "@core/translation.service";
import { DownloadFileService } from "./user/documents/documents-services/downloadFile.service";
import { TranslationComponent } from "./user/translation/translation.component";
import { InactionPopupComponent } from "./inaction-popup/inaction-popup.component";
import { DialogService, DynamicDialogModule } from "primeng/dynamicdialog";
import { CryptoSignService } from "@core/crypto-sign.service";

registerLocaleData(localeRuBy, "ru-By");
registerLocaleData(tk, 'tk');
registerLocaleData(kkKZ, 'kk-KZ');

@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        CryptoMobileComponent,
        TranslationComponent,
        InactionPopupComponent
    ],
    imports: [
        AppRouterModule,
        BrowserAnimationsModule,
        UserCoreModule,
        BrowserModule,
        CoreModule,
        SharedModule,
        DynamicDialogModule,
        EffectsModule.forRoot([]),
        StoreModule.forRoot({}, {
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
                strictStateSerializability: false,
                strictActionSerializability: false,
            }
        }),
        StoreDevtoolsModule.instrument({ maxAge: 25 }),
    ],
    providers: [
        // { provide: LOCALE_ID, useValue: "ru-By" },
        /**
         * { provide: LOCALE_ID, useValue: "tk" } this locale for calendar
         */
        // { provide: LOCALE_ID, useValue: "tk" },
        { provide: LOCALE_ID, useFactory: getLocale },
        TranslationService,
        DownloadFileService,
        DialogService,
        { provide: "TranslateComponent", useValue: TranslationComponent },
        CryptoSignService,
    ]
})
export class AppModule { }

function getLocale(): string {
    return location.pathname.includes("tk") ? "tk" : "ru-By";
}